<template>
  <nav class="navbar">
    <div class="nav-container">
      <router-link to="/" class="logo">
        <img src="@/assets/images/logo.svg" alt="Lumivan">        
      </router-link>      
      <div class="logo-text">
          <h1 class="logo-title">{{ $t('navigation.logoTitle') }}</h1>
          <p class="logo-subtitle">{{ $t('navigation.logoSubtitle') }}</p>
      </div>
      <button class="menu-toggle" @click="toggleMenu" aria-label="导航菜单">
        <i class="fas" :class="isMenuOpen ? 'fa-times' : 'fa-bars'"></i>
      </button>

      <ul class="nav-links" :class="{ active: isMenuOpen }">
        <li v-for="(item, index) in navItems" :key="index">
          <router-link 
            :to="{ name: item.route }"
            class="nav-link"
            active-class="active-link"
            @click="closeMenu"
          >
            {{ $t(`navigation.${item.key}`) }}
            <span class="link-underline"></span>
          </router-link>
        </li>
        <li class="language-switcher-container">
          <LanguageSwitcher />
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue'

export default {
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      isMenuOpen: false,
      navItems: [
        { key: 'products', route: 'products' },
        { key: 'pricing', route: 'pricing' },
        { key: 'faq', route: 'faq' },
        { key: 'about', route: 'about' }
      ]
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  height: 60px; /* 固定高度 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.logo-title {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 900;
  font-size: 1.4rem;
  margin: 0;
  color: #2c3e50;
  letter-spacing: 0.05em;
  text-decoration: none !important;
}

.logo-subtitle {
  font-size: 0.8rem;
  margin: 0;
  color: #007bff;
  font-weight: 500;
  text-decoration: none !important;
}

.logo img {
  width: 120px; /* 调整所需宽度 */
  height: auto; /* 保持比例 */
  transition: transform 0.3s ease;
}

.logo:hover img {
  transform: scale(1.05);
}

.nav-links {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-link {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  padding: 0.5rem 0;
  transition: color 0.3s ease;
}

.active-link {
  color: #007bff;
}

.link-underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #007bff;
  transition: width 0.3s ease;
}

.nav-link:hover .link-underline,
.active-link .link-underline {
  width: 100%;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #2c3e50;
  cursor: pointer;
}

.language-switcher-container {
  margin-left: 1.5rem;
}

@media (max-width: 768px) {
  .logo {
    gap: 0.5rem;
  }
  
  .logo-title {
    font-size: 1.1rem;
  }
  
  .logo-subtitle {
    font-size: 0.65rem;
  }
  
  .logo img {
    width: 60px; /* 适当缩小移动端logo */
  }
  .nav-links {
    position: fixed;
    top: 70px;
    right: -100%;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.98);
    width: 100%;
    padding: 2rem;
    transition: right 0.3s ease;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }

  .nav-links.active {
    right: 0;
  }

  .menu-toggle {
    display: block;
  }

  .nav-link {
    font-size: 1.2rem;
    padding: 1rem 0;
  }

  .language-switcher-container {
    margin-left: 0;
    width: 100%;
    padding-top: 1rem;
    border-top: 1px solid #eee;
  }

  .navbar {
    height: 50px;
    position: sticky; /* 移动端改为sticky定位 */
  }
}

@media (max-width: 480px) {
  .logo-text {
    display: none; /* 超小屏幕隐藏文字 */
  }
}
</style>
